import KeenSlider from "keen-slider";
import InfoModal from "./InfoModal";

class NeighborhoodEvents {
	constructor(dom) {
		this.dom = dom;
		this.track = dom.querySelector("[data-ne-track]");
		this.nextBtn = dom.querySelector("[data-ne-next]");
		this.filterBtns = dom.querySelectorAll(".ne-filter-btn");
		this.slider = null;
		this.activeFilter = "all";
		this._pointerStartX = 0;
		this.modal = new InfoModal();
	}

	init() {
		if (!this.track) return;
		this._allSlides = Array.from(
			this.track.querySelectorAll(".neighborhood-events__slide")
		);
		this._buildSlider(this._allSlides.length);
		this._bindFilters();
		this._bindNext();
		this.modal.init();
		this._bindCards();
	}

	_isDesktop() {
		return window.matchMedia("(min-width: 1024px)").matches;
	}

	_shouldDisable(count) {
		return this._isDesktop() ? count <= 4 : count <= 1;
	}

	_buildSlider(count) {
		if (this._shouldDisable(count)) {
			this.dom.classList.add("is-static");
			return;
		}
		this.dom.classList.remove("is-static");
		this.slider = new KeenSlider(this.track, {
			loop: true,
			slides: { perView: 1.2, spacing: 20, origin: "center" },
			breakpoints: {
				"(min-width: 640px)": {
					slides: { perView: 2.2, spacing: 20, origin: "center" },
				},
				"(min-width: 1024px)": {
					slides: { perView: 3.9, spacing: 75, origin: "center" },
				},
			},
		});
	}

	_rebuildSlider(count) {
		if (this.slider) {
			this.slider.destroy();
			this.slider = null;
		}
		this._buildSlider(count);
	}

	_bindCards() {
		this.track.addEventListener("pointerdown", (e) => {
			this._pointerStartX = e.clientX;
		});

		this.track.addEventListener("click", (e) => {
			if (Math.abs(e.clientX - this._pointerStartX) > 6) return;
			const card = e.target.closest(".neighborhood-events__card");
			if (!card) return;
			const slide = card.closest("[data-event]");
			if (!slide) return;
			try {
				const data = JSON.parse(slide.dataset.event);
				this.modal.open(data);
			} catch (e) {}
		});
	}

	_bindFilters() {
		this.filterBtns.forEach((btn) => {
			btn.addEventListener("click", () => {
				const filter = btn.dataset.filter;
				if (filter === this.activeFilter) return;
				this.activeFilter = filter;
				this._applyFilter(filter);
				this._updateFilterUI(btn);
			});
		});
	}

	_applyFilter(filter) {
		const matching =
			filter === "all"
				? this._allSlides
				: this._allSlides.filter((slide) =>
						(slide.dataset.filters || "").split(" ").includes(filter)
				  );

		this.track.innerHTML = "";
		matching.forEach((slide) => this.track.appendChild(slide));

		this._rebuildSlider(matching.length);
	}

	_updateFilterUI(activeBtn) {
		const isAll = activeBtn.dataset.filter === "all";

		this.filterBtns.forEach((btn) => {
			btn.classList.remove("is-active", "is-inactive");
			if (btn === activeBtn) {
				btn.classList.add("is-active");
			} else if (!isAll) {
				btn.classList.add("is-inactive");
			}
		});
	}

	_bindNext() {
		if (!this.nextBtn) return;
		this.nextBtn.addEventListener("click", () => {
			if (this.slider) this.slider.next();
		});
	}
}

export default NeighborhoodEvents;
